var map = {
	"./bg-bottom-pad.png": 3323,
	"./bg-bottom.png": 2355,
	"./bg-top-pad.png": 3878,
	"./bg-top.png": 2105,
	"./cloth-select.png": 5767,
	"./cloth.png": 5912,
	"./lose-text.png": 1753,
	"./lose.png": 5965,
	"./scissor-select.png": 8641,
	"./scissor.png": 4670,
	"./score-10.png": 1482,
	"./score-6.png": 8503,
	"./score-8.png": 4873,
	"./stone-select.png": 6930,
	"./stone.png": 1511,
	"./student-bg.png": 9357,
	"./teacher-bg.png": 7188,
	"./title.png": 4382,
	"./win-text.png": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2773;